export default class OptionForklift {
    constructor() {
    }
    getHtml = function(){
        return `
<div class="fork_lift a">
    <h2 class="title1">기종선택</h2>
    <div class="flex">
        <div class="left flex_column main-button-area">
            <div class="item flex" data-index="1" data-range="1~4">일반<span class="fz_10 fw_semobild   ml-05 mt-2">(엔진)</span></div>
        </div>
        <div class="right flex_column sub-button-area">
            <div class="flex" data-index="1">
                <div class="item flex_column" data-index="1" data-code="410">3T</div>
                <div class="item flex_column" data-index="2" data-code="412">4.5T</div>
                <div class="item flex_column" data-index="3" data-code="414">5T</div>
                <div class="item flex_column" data-index="4" data-code="416">7T</div>
            </div>
        </div>
    </div>
    <h2 class="title1">옵션선택</h2>
    <div class="option flex_column">
        <div class="division_3 flex">
            <div class="item flex" data-value="3단마스터" data-code="400">
                3단마스터
            </div>
            <div class="item flex" data-value="지하" data-code="410" data-constraint="X:S:1,2" data-constraint-errmsg="지하작업은 3톤 / 4.5톤만 가능합니다.">
                지하
            </div>
            <select class="item-select flex_space_around" data-value="전고">
                <option value="">전고</option>
            </select>
        </div>
    </div>
    <div class="car-example"></div>
    <div class="blank"></div>
    <div class="button flex apply-data">
        <div class="button_yellow flex">완료</div>
    </div>
</div>`;
    }
    /**
     * 화면 초기화
     * @param parent OptionWindow 인스턴스
     */
    init = function(parent) {
        this.parent=parent;
        console.log('window.option.forklift.init');
        this.parent.load();// 변수 초기화
        this.parent.drawJungo();// 전고 그리기 ( 최초한번만 )
        this.parent.draw();// 톤수,미터를 그린다.
        this.parent.initMainButtonHandler();// 메인 버튼을 클릭했을때
        this.parent.initSubButtonHandler();// 서브 버튼을 클릭했을때
        this.parent.initOptionHandler();// 옵션버튼 클릭시
        this.parent.initApplyHandler();// 완료버튼 클릭시
    }

    /**
     * car_range 값을 업데이트한다.
     */
    updateRange = function (){
        const self = this;
        const arr = [];
        // 서브버튼 순회
        $('#'+this.parent.id+" .sub-button-area .item").each(function(){
            const idx = $(this).attr('data-index');
            if( self.parent.subIdxList.includes(idx) ) arr.push( $(this).attr('data-code'));
        });

        // const arr = this.parent.subCodeList;
        const min = Math.min(...arr);
        const max = Math.max(...arr);
        let range = '';
        range = `${min}~${max}`;
        const data = this.parent.data;
        data['car_range']=range;
    }
}
